import { handleActions } from "redux-actions";
import * as apiActions from "../actions";

const defaultState = {
  error: "",
  customerData: [],
  pageState: {},
  earlyFeedback:{},
  fetchTestData:[],
  botReportData:[],
  createCustomer:{},
  customerNameExist:{},
  isRedirected:false


};

export const customer = handleActions(
  {
    [apiActions.customerSuccess]: (state, action) => {
      return {
        ...state,
        customerData: action.payload,
      };
    },
    [apiActions.customerFail]: (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    },
    [apiActions.fetchTokenFail]: (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    },
    [apiActions.getPageSateSuccess]: (state, action) => {
      return {
        ...state,
        pageState: action.payload,
      };
    },
    [apiActions.createCustomerNameSuccess]: (state, action) => {
      return {
        ...state,
        createCustomer: action.payload,
      };
    },
    [apiActions.getCustomerNameSuccess]: (state, action) => {
      return {
        ...state,
        customerNameExist: action.payload,
      };
    },
    [apiActions.getCustomerNameFail]: (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    },
    [apiActions.uiEarlyFeedbackSuccess]: (state, action) => {
      return {
        ...state,
        earlyFeedback: action.payload,
      };
    },
    [apiActions.fetchTestDataSuccess]: (state, action) => {
      return {
        ...state,
        fetchTestData: action.payload,
      };
    },
    [apiActions.checkEmailsSuccess]: (state, action) => {
      return {
        ...state,
        customerData:{ ...state.customerData, ...action.payload} 
      }
      
    },
    [apiActions.getReportSuccess]: (state, action) => {
      return {
        ...state,
        // botReportData: [...state.botReportData, {...action.payload}] 
        botReportData: action.payload 
      }
      
    },
    [apiActions.redirectFromPSSuccess]: (state, action) => {
      return {
        ...state,
        isRedirected: action.payload 
      }
      
    },
    [apiActions.getReportClear]: (state, action) => {
      return {
        ...state,
        botReportData: [] 
      }
      
    },
  },
  defaultState
);
